import { useState } from 'react';
import { toast } from 'sonner';
import type { CachePurgeScope } from '@bailafm/shared';
import { Button } from '@/components/ui/button';
import { ApiClientError, cacheApi } from '@/lib/api';

// Superficies purgables individualmente (las tags gruesas conocidas).
const SURFACES: { scope: CachePurgeScope; label: string }[] = [
  { scope: 'events', label: 'Eventos' },
  { scope: 'collections', label: 'Colecciones' },
  { scope: 'home', label: 'Home' },
  { scope: 'blog', label: 'Blog' },
  { scope: 'search-chips', label: 'Chips del hero' },
  { scope: 'artists', label: 'Artistas' },
  { scope: 'cities', label: 'Ciudades' },
];

export default function ConfiguracionPage() {
  const [pending, setPending] = useState<CachePurgeScope | null>(null);

  async function purge(scope: CachePurgeScope, label: string) {
    setPending(scope);
    try {
      await cacheApi.purge(scope);
      toast.success(`Caché vaciada: ${label}`);
    } catch (err) {
      toast.error(
        err instanceof ApiClientError ? err.message : 'No se pudo vaciar la caché',
      );
    } finally {
      setPending(null);
    }
  }

  return (
    <div className="max-w-2xl space-y-8">
      <div>
        <h1 className="text-2xl font-semibold">Configuración</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Herramientas de mantenimiento del sitio.
        </p>
      </div>

      <section className="space-y-4 rounded-lg border p-6">
        <div>
          <h2 className="text-lg font-medium">Caché de la web</h2>
          <p className="mt-1 text-sm text-muted-foreground">
            Fuerza el refresco del contenido publicado en baila.fm sin esperar
            a que caduque. Útil tras un cambio urgente.
          </p>
        </div>

        <Button
          disabled={pending !== null}
          onClick={() => void purge('all', 'todo el sitio')}
        >
          {pending === 'all' ? 'Vaciando…' : 'Vaciar toda la caché'}
        </Button>

        <div className="space-y-2">
          <p className="text-sm font-medium">O solo una sección:</p>
          <div className="flex flex-wrap gap-2">
            {SURFACES.map(({ scope, label }) => (
              <Button
                key={scope}
                variant="outline"
                size="sm"
                disabled={pending !== null}
                onClick={() => void purge(scope, label)}
              >
                {pending === scope ? 'Vaciando…' : label}
              </Button>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
